<template>
  <div
    v-touch:start.passive="getStart"
    v-touch:end.passive="triggerEnd"
    v-touch:moving.passive="updatePosition"
    ref="siteplan"
    class="siteplan absolute absolute--fill z-0 tc"
    :style="'transform: translate(' + (offsetX + xPos) + 'px, ' + (offsetY + yPos) + 'px) scale(' + scale + ');'"
  />
</template>

<script>
import axios from 'axios'

const find = require('lodash/find')

export default {
  name: 'SitePlan',
  props: {
    development: {
      type: Object,
      default: null
    },
    plots: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      scale: 1,
      xPos: 0,
      yPos: 0,
      startXPos: 0,
      startYPos: 0,
      offsetX: 0,
      offsetY: 0
    }
  },
  computed: {
    activeFilters () {
      return this.$store.state.siteplan.filters
    },
    isFiltered () {
      if (this.activeFilters.availability || this.activeFilters.bedrooms || this.activeFilters.price || this.activeFilters.purchaseType || this.activeFilters.style || this.activeFilters.type) {
        return true
      } else {
        return false
      }
    },
    svgPlots () {
      return this.$refs.siteplan.querySelectorAll('g[id^=Plot]')
    },
    svgDots () {
      return this.$refs.siteplan.querySelectorAll('g[id^=D]')
    },
    filteredPlots () {
      const plots = this.plots.slice(0)
      plots.forEach(element => {
        element.visible = true
      })

      if (this.isFiltered) {
        plots.forEach(element => {
          if (this.activeFilters.availability && this.activeFilters.availability !== element.statusCode) {
            element.visible = false
          }
          if (this.activeFilters.bedrooms && this.activeFilters.bedrooms !== element.bedroomsCount) {
            element.visible = false
          }
          if (this.activeFilters.price.display) {
            if (!element.price) {
              element.visible = false
            } else if (element.price < this.activeFilters.price.min * 1000 || element.price > this.activeFilters.price.max * 1000) {
              element.visible = false
            }
          }
          if (this.activeFilters.purchaseType && this.activeFilters.purchaseType !== element.sellingType) {
            element.visible = false
          }
          if (this.activeFilters.style && this.activeFilters.style !== element.houseType) {
            element.visible = false
          }
          if (this.activeFilters.type && this.activeFilters.type !== element.unitType) {
            element.visible = false
          }
        })
      }
      return plots
    }
  },
  mounted () {
    this.injectSVG()
    // this.updateSVG()
    setTimeout(() => {
      this.updateSVG()
    }, 1000)
    this.$store.subscribe((mutation, state) => {
      const watchMutations = [
        'clearFilters',
        'setFilterAvailability',
        'setFilterBedrooms',
        'setFilterPlots',
        'setFilterPrice',
        'setFilterPurchaseType',
        'setFilterStyle',
        'setFilterType'
      ]

      if (watchMutations.includes(mutation.type)) {
        this.updateSVG()
      }

      setTimeout(() => {
        this.updateSVG()
      }, 1000)
    })
  },
  methods: {
    injectSVG () {
      const siteplan = this.$refs.siteplan
      axios.get(this.development.siteplan)
        .then((response) => {
          siteplan.innerHTML = response.data
        })
        .then(() => {
          const svg = siteplan.querySelector('svg')
          svg.classList.add('mw-100', 'vh-100')
          this.addEventListeners()
          this.addAvailabilityDots()
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    updateSVG () {
      this.svgPlots.forEach(element => {
        const plotNumber = element.id.replace('Plot_', '').padStart(3, '0')
        const vectors = element.querySelectorAll('[class]')
        const target = find(this.filteredPlots, ['name', 'Plot ' + plotNumber])
        if (target && target.visible) {
          vectors.forEach(vector => {
            vector.style.fill = null
            vector.style.pointerEvents = 'auto'
          })
        } else {
          vectors.forEach(vector => {
            vector.style.fill = '#DDDDDD'
            vector.style.pointerEvents = 'none'
          })
        }
      })
    },
    addAvailabilityDots () {
      this.svgDots.forEach(element => {
        const plotNumber = element.id.replace('D', '').padStart(3, '0')
        const target = find(this.plots, ['name', 'Plot ' + plotNumber])
        let colour
        if (target) {
          switch (target.statusCode) {
            case 'Available':
              colour = 'green'
              break
            case 'Early Bird Released':
              colour = 'blue'
              break
            case 'Reserved':
              colour = 'black'
              break
            case 'Sold':
              colour = 'red'
              break
            default:
              colour = 'white'
              break
          }
          element.querySelector('*').style.fill = colour
        }
      })
    },
    addEventListeners () {
      const self = this
      const siteplan = this.$refs.siteplan
      const nodes = siteplan.querySelectorAll('svg *')

      nodes.forEach(element => {
        element.style.pointerEvents = 'none'
      })

      const plots = this.svgPlots
      let i = 0
      plots.forEach(plot => {
        const children = plot.querySelectorAll('*')
        children.forEach(child => {
          child.addEventListener('click', () => {
            self.selectPlot(parseInt(plot.id.replace('Plot_', '')))
          })

          child.style.pointerEvents = 'auto'
          child.style.transition = 'fill'
          child.style.transitionDelay = (0.01 * i) + 's'
          child.style.transitionDuration = '0.35s'
        })
        i++
      })
    },
    selectPlot (id) {
      this.$emit('select', id)
    },
    zoom (direction) {
      if (direction === 'in') {
        this.scale = this.scale + 0.3
      } else {
        if (this.scale > 0.8) {
          this.scale = this.scale - 0.3
        }
      }
    },
    getStart (event) {
      if (event.touches) {
        const x = event.touches[0].clientX
        const y = event.touches[0].clientY
        this.startXPos = x
        this.startYPos = y
      }
    },
    triggerEnd (event) {
      if (event.touches) {
        this.offsetX = this.xPos + this.offsetX
        this.offsetY = this.yPos + this.offsetY
        this.xPos = 0
        this.yPos = 0
      }
    },
    updatePosition (event) {
      if (event.touches) {
        const x = event.touches[0].clientX
        const y = event.touches[0].clientY
        let movementX
        let movementY
        if (this.startXPos === 0) {
          this.startXPos = x
          this.startYPos = y
        } else {
          movementX = this.startXPos - x
          movementY = this.startYPos - y
          if (Math.sign(movementY) === 1) {
            movementY = Math.abs(movementY) * -1
          } else {
            movementY = Math.abs(movementY)
          }
          if (Math.sign(movementX) === 1) {
            movementX = Math.abs(movementX) * -1
          } else {
            movementX = Math.abs(movementX)
          }
          this.xPos = movementX
          this.yPos = movementY
        }
      }
    }
  }
}
</script>
